<template>
  <v-text-field
    v-model="delivery.code"
    maxlength="6"
    :disabled="delivery.loading || !!delivery.amount"
    :error-messages="delivery.errors.code"
    :label="$t('CART.DELIVERY_CODE')"
    :loading="delivery.loading"
  >
    <template v-if="delivery.amount" v-slot:prepend-inner>
      <v-icon size="20" class="mr-2" color="green">fas fa-check</v-icon>
    </template>
    <template v-if="delivery.amount" v-slot:append>{{ delivery.amount }}</template>
  </v-text-field>
</template>

<script>
import debounce from "@/utils/TinyDebounce";

export default {
  data() {
    return {
      delivery: {
        code: null,
        errors: {},
        loading: false,
        amount: null
      }
    };
  },

  watch: {
    "delivery.code": debounce(function(val) {
      this.onCodeChange(val);
    }, 500)
  },

  methods: {
    async onCodeChange(e) {
      if (!this.$cart.country.id) return;

      if (e.length === 6) {
        this.delivery.loading = true;

        // reset delivery related data
        this.delivery.errors = {};
        this.delivery.amount = null;

        try {
          const res = await this.$axios.get(
            `/cart/delivery-code?code=${e}&country_id=${this.$cart.country.id}`
          );
          this.delivery.amount = res.data.data.amount;
          this.$emit("onDeliverySuccess", this.delivery.code);
        } catch (error) {
          if (error.status === 422 && error.data) {
            this.delivery.errors = error.data.errors;
          }
        }
        this.delivery.loading = false;
      }
    }
  }
};
</script>